import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    gap: 20px;

    overflow-y: scroll;
    height: 470px;

    &::-webkit-scrollbar { 
        width: 5px;
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    &::-webkit-scrollbar-thumb{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        border-radius: 20px;
    }
`;

export const ContentProgress = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 30px;
`;

export const SeparateDiv = styled.div`
    display: flex;
    gap: 20px;
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    input[type='text']{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.error};
        margin-left: 3px;
    }
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const ContentCheck = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    color: ${(props) => props.theme.colors.gray.gray_500};
`;

export const ContentDiv = styled.div`
    display: flex;
    padding: 10px 0px;
    gap: 15px;
`;

export const CheckBox = styled.input`
  width: 18px;
  height: 18px;
  appearance: none;
  cursor: pointer;

  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.gray.gray_100};

  &:checked {
    background-color: ${(props) => props.theme.colors.primary};
    border-color: ${(props) => props.theme.colors.primary}; /* Borda ao marcar */
  }

  &:hover {
    border-color:${(props) => props.theme.colors.primary}; /* Cor ao passar o mouse */
  }

  &::after {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    margin: 3px auto;
    color: ${(props) => props.theme.colors.white};
    opacity: 0;
    transition: opacity 0.2s ease;
  }
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.error};
    font-size: 12px;
`;

export const ModalCalculate = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    gap: 20px;
`;

export const HeadCalc = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 0px;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};

    p{
        font-weight: 500;
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
`;

export const ButtonCalc = styled.button`
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) => props.theme.colors.gray.gray_800};

    padding: 8px 15px;
    border-radius: 30px;
`;

export const FormsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const HeaderSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 5px 0px;
    
    border-bottom: 2px solid ${(props) => props.theme.colors.gray.gray_100};
    color: ${(props) => props.theme.colors.gray.gray_200};
`;